var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0_1056_2930)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1056_2930",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1056_2930",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1056_2930",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEG0lEQVR4nO2dy48MURTGf8kYwjCC8Qwbb2I3JFjwL3gbj0hsEQQzCysRmyERZoHwf0hmSyIxJMLGe4VYiIkw3o8rl5sYN9Wte0zVOXXrfMlJJtOP+s7361tVfav7NphMJpPJZDKZTLOBnUAf0A88BgaBL6EGw//8beeBHcAsi2101QEcAm4DboQ1ABwMz2UaoeaFkfDhP0DE9T6MnLlGpXG1hhHxbhRBxOUhnwDGGZj6WgbcqxPkV+AacBLYGO4/JUBsDX8vD7f5+1wPj6n1fHeBpQYlW9uAoRrBPQEOAzNGEN7M8NinNZ7bj8QtBuVv7Qe+Z4T1HNgNtIxCYGOAPcCLjO34be8zKH9gZL1yLwGTcgipHbhcY5uVh7ItY2R8BLoKeLXuDNuKR8pmKqplGceMN8C6Aj2sD9uMjymLqZjGZpxNfSgYxnAo8Ui5E87aKqPjGfvvLkE/uzL89FChd+DvMw7g0roSefK70zlUQH1R4y+BydKm+H32FZ8SnyVxTc+Ym/LvM7Rob8YomUbCOhw1/DS8YdOiljB9P9zjARJWPIXuAWnTkcjjTRK+uPQjmij080wafX4b5vNHqhe54lNLP2urVTcir9upwNmVnx7XqlOR13MkqP6oyQ3o1ebI61USVHw9wl9I0qoVkVd/5pWcXkdNTkWvOiKvr0hQn6Mm/QSjVo2LvH4iQcWTd9rlSuY3+QZdyfwm36Armd/kG3Ql85t8g65kfpNv0JXMb/INupL5Tb5BVzK/yTfoSuY3+QZdyfzSFj4qc7vOh6SrVEPALaAbmFA0jIXAIwUhOKX1AFhQ5Mh4qKBpVwIohYyUHgXNupLUsSKA/M+XL6tWA0UAsQM4DQPxn6TPXdKvOleyMiDIQzAgyAdvQJAP24AgH7ABQT5UA4J8kAYE+fAMiILAnAGRD8kZEPlgnAGRD8MpKJs6QR6CAUE++MoDGQJ6gc5wFdPXSuB0xkoRBiTnEB4Di+rsnJeEVeicgkr+GDLU4PJJS5SMlNwl3WBvE17PKPCbu6Qb7GzC6yoFfnOXdINtTXidqMBv7pJusL0Jr5MV+M1d0g2ubsLrGgV+c5d0gxea8HpRgd/cJd3g1wZHydp/LDNuQEYxhMEGgAwqgFGJEeIabFTanwGJJA3CgESSBmFAIkmDMCCRpEFUDsgk5e/QKwdkUxNL9BmQAkJ4WGNVuqnKvpCau5yiegZsDROO7WFkaIJROSCuBGVAkIdgQJAP3oAgH7YBQT5gA4J8qAYE+SANCPLhGRAFgTkDIh+SMyDywTgDIh+GU1A2dYI8BANChYG8U9CkK0m9LQKILfGHriX+uhW88lxJyv9qaO5qC0ugSjfrlNd9YDwFyS8SbFCoC2M+BcsvEnw0/HivrVTKrwx8Fn43NeKR8RONU1WB0VKjnAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a46b0d2e016970058305d254236f7e6c.svg";
export { ForwardRef as ReactComponent };